import * as web3Types from '../types/web3Types';

export const storeWeb3Context = (data) => {
  return (dispatch) => {
    dispatch({ type: web3Types.STORE_WEB3_CONTEXT, payload: data });
  };
};

export const updateThorPrice = (price) => {
  return (dispatch) => {
    dispatch({ type: web3Types.UPDATE_THOR_PRICE, payload: price });
  };
};

export const updateAvaxPrice = (price) => {
  return (dispatch) => {
    dispatch({ type: web3Types.UPDATE_AVAX_PRICE, payload: price });
  };
};
